exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.BalanceTooltip_content_27uF {\n  color: #787878;\n}\n.BalanceTooltip_amountWrapper_3pK9 {\n  margin-bottom: 15px;\n}\n.BalanceTooltip_amount_2QB3 {\n  margin-bottom: 5px;\n\n  font-family: \"BeelineSans\", arial, sans-serif;\n  font-size: 18px;\n\n  color: #282828;\n}\n.BalanceTooltip_calculationWrapper_1ZXo {}\n.BalanceTooltip_calculation_2efH {\n  border-bottom: 2px solid #a9a9a9;\n}\n.BalanceTooltip_total_5U9q {\n  margin-top: 15px;\n  margin-bottom: 25px;\n}\n", ""]);

// exports
exports.locals = {
	"content": "BalanceTooltip_content_27uF",
	"amountWrapper": "BalanceTooltip_amountWrapper_3pK9",
	"amount": "BalanceTooltip_amount_2QB3",
	"calculationWrapper": "BalanceTooltip_calculationWrapper_1ZXo",
	"calculation": "BalanceTooltip_calculation_2efH",
	"total": "BalanceTooltip_total_5U9q"
};